import type React from 'react';
import { lazy } from 'react';
import { LazyDependency } from '../LazyDependency.tsx';
import type { SheetEditorProps } from './SheetEditor.tsx';

const LazySheetEditorImpl = lazy(() => import('./SheetEditor.tsx').then(m => ({ default: m.SheetEditor })));

/**
 * The sheet editor pulls @dnd-kit, which nothing else in the app needs. Only the three
 * Sheets screens render it, so it is loaded on demand.
 */
export const LazySheetEditor: React.FC<SheetEditorProps> = props => (
  <LazyDependency height="300px">
    <LazySheetEditorImpl {...props} />
  </LazyDependency>
);
